module.exports = __webpack_public_path__ + "static/media/success-icon.1ac3b387.svg";